import React, { useEffect, useState } from "react";
import HandlingResponse from "../../../common/handling-response/handlingResponse";
import ActKindClient from "../../api-services/coders/act-kind/act-kind-client";
import { useTranslation } from "react-i18next";
import Joi from "joi-browser";
import {
  handleSave,
  validateForm,
  serverValidation,
} from "../../../common/validation/validation";
import Moment from "moment";

const CreateLegislativeActType = ({ row, handleCallback, isCreate }) => {
  const [legislativeActType, setLegislativeActType] = useState({
    id: 0,
    name: "",
    weight: 0,
    isActive: true,
    userFullName: "",
    lastModifyDate: null,
  });

  const { t } = useTranslation();
  const [errors, setErrors] = useState({});
  const schema = {
    name: Joi.string().required(),
    weight: Joi.number().min(0).max(2147483647).required(),
  };

  const client = new ActKindClient();

  useEffect(() => {
    setLegislativeActType(row);
    setErrors({});
  }, [row, isCreate]);

  const CreateLegislativeActType = async () => {
    const errorsResult = validateForm(legislativeActType, schema, t);
    setErrors(errorsResult);

    if (!errorsResult) {
      const data = {
        ...legislativeActType,
        weight: parseInt(legislativeActType.weight),
        lastModifyDate: new Date(),
      };
      var response = await client.CreateActKind(data);
      var handledResponse = HandlingResponse(response);
      if (handledResponse.code == 408) {
        var result = serverValidation(handledResponse.data, t);
        setErrors(result);
      } else handleCallback(handledResponse);
    }
  };

  const UpdateLegislativeActType = async () => {
    const errorsResult = validateForm(legislativeActType, schema, t);
    setErrors(errorsResult);

    if (!errorsResult) {
      const data = {
        ...legislativeActType,
        weight: parseInt(legislativeActType.weight),
        lastModifyDate: new Date(),
      };
      var response = await client.UpdateActKind(legislativeActType.id, data);
      var handledResponse = HandlingResponse(response);
      if (handledResponse.code == 408) {
        var result = serverValidation(handledResponse.data, t);
        setErrors(result);
      } else handleCallback(handledResponse);
    }
  };

  const handlePropertyChange = (event, date) => {
    const obj = date
      ? { name: date, value: event }
      : { name: event.name, value: event.value };
    const result = handleSave(obj, legislativeActType, errors, schema, t);
    setLegislativeActType(result.data);
    setErrors(result.errors);
  };

  return (
    <>
      <form>
        <div className="form-group">
          <label>Назив<span className="required-asterisk">*</span></label>
          <input
            className="form-control"
            type="text"
            name="name"
            value={legislativeActType.name}
            onChange={(event) => handlePropertyChange(event.target)}
          />
          {errors?.name && <div className="text-danger">{errors.name}</div>}
        </div>
        <div className="form-group">
          <label>Тежина<span className="required-asterisk">*</span></label>
          <input
            className="form-control"
            type="number"
            name="weight"
            value={legislativeActType.weight}
            onChange={(event) => handlePropertyChange(event.target)}
          />
          {errors?.weight && <div className="text-danger">{errors.weight}</div>}
        </div>
        <div>
        <input
                id="activeActTypeCB"
                    type="checkbox"
                    value={legislativeActType.isActive}
                    checked={legislativeActType.isActive}
                    onChange={(event) => {
                        setLegislativeActType({ ...legislativeActType, isActive: event.target.checked });
                    }}
          />
          <label htmlFor="activeActTypeCB">Активан</label>
        </div>
          {!isCreate ? (
          <>
            <div className="form-group">
              <label>Идентификатор</label>
              <div>{legislativeActType.id}</div>
            </div>
            <div className="form-group">
              <label>Корисник</label>
              <div>{legislativeActType.userFullName}</div>
            </div>
            <div className="form-group">
              <label>Датум и време последње измене</label>
              <div>
                {Moment(legislativeActType.lastModifyDate).format("DD.MM.YYYY.")}
              </div>
            </div>
          </>
        ) : (
          ""
        )}
          
        <div className="text-right">
          {isCreate ? (
            <button
              className="btn btn-primary m-2"
              type="button"
              onClick={() => CreateLegislativeActType()}
            >
              Сачувај
            </button>
          ) : (
            <button
              className="btn btn-primary m-2"
              type="button"
              onClick={() => UpdateLegislativeActType()}
            >
              Сачувај измене
            </button>
          )}
        </div>
      </form>
    </>
  );
};

export default CreateLegislativeActType;
